import {Directive, ElementRef, Host, Optional} from '@angular/core';
import {UiButtonComponent} from '../../ui-button/ui-button.component';
import {UiHighlightComponent} from '../../ui-highlight/ui-highlight.component';
import {UiDropdownComponent} from '../../ui-dropdown/ui-dropdown.component';

@Directive({
    selector: '[card-action]',
    standalone: false
})
export class CardActionDirective {

    constructor(
        private el: ElementRef,
        @Optional() @Host() public button?: UiButtonComponent,
        @Optional() @Host() public highlight?: UiHighlightComponent,
        @Optional() @Host() public dropdown?: UiDropdownComponent) {
    }

}
